import { Selector } from '@ngxs/store';
import { ProfilesState, ProfilesStateModel } from './profiles.state';

export class ProfilesSelectors {
    @Selector([ProfilesState])
    static allProfiles(state: ProfilesStateModel) {
        return state?.profiles;
    }

    @Selector([ProfilesSelectors.allProfiles])
    static hasMultipleProfiles(profiles: any[]): boolean {
        return (profiles?.length ?? 0) > 1;
    }

    @Selector([ProfilesSelectors.allProfiles])
    static selectedUserProfile(profiles: any[]): any | null {
        const selected = profiles?.find(profile => profile?.selected === true) ?? null;
        return selected;
    }

    @Selector([ProfilesState])
    static loaded(state: ProfilesStateModel): boolean {
        return state.loaded;
    }
}
